import { defineStore } from 'pinia'
import axios from 'axios'
import { api } from '@/plugins/api'
import { authStore } from '@/stores/auth'

// Issue 622: PDF estimate upload/review for Blueprint. The parse + confirm endpoints live in the ADAS
// Map API (bms/pdf/*); we call them cross-service with the current user's token. Parse is multipart, which
// the shared api.js client can't send, so it uses an authenticated axios call; confirm is plain JSON.
export const estimateStore = defineStore('estimate', {
  state: () => ({
    parsing: false,
    submitting: false
  }),
  actions: {
    // Returns PdfParseResult: { blobKey, fileName, contentType, byteSize, estimate }
    async parsePdf({ file, firm, source, quality }) {
      const apiUrl = window.config ? window.config.apiUrl : ''
      const form = new FormData()
      form.append('file', file)
      form.append('firm', firm)
      if (source) form.append('source', source)
      if (quality) form.append('quality', quality)
      this.parsing = true
      try {
        const resp = await axios.post(`${apiUrl}/bms/pdf/parse`, form, {
          headers: { Authorization: `Bearer ${authStore().token}` }
        })
        return resp.data
      } finally {
        this.parsing = false
      }
    },
    // Returns PdfEstimateConfirmResult: { adas, adasInspection, scrubbed }
    async confirmPdf(payload) {
      this.submitting = true
      try {
        return await api.post('bms/pdf/confirm', payload)
      } finally {
        this.submitting = false
      }
    }
  }
})
